import React from 'react';
import './SimpleLineChart.scss';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';

const SimpleLineChart = ({
  data,
  title,
  lineColor,
  gradientStart,
  gradientEnd,
  offsetStart,
  offsetEnd
}) => {
  const gradientId = `gradient-${Math.random().toString(36).slice(2, 11)}`; // آیدی یونیک برای گرادیانت

  return (
    <div className='simple-line-chart'>
      <h2>{title}</h2>
      <div className='simple-line-chart-inner'>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
          >
            <CartesianGrid vertical={false} strokeDasharray="0" stroke="#EAEAEA" />
            <XAxis
              tick={{ fontSize: 12, dy: 15 }}
              interval={0}
              angle={0}
              dataKey="name"
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tickFormatter={(tick) => tick.toLocaleString('fa-IR')}
              domain={[0, data && data.length > 0 ? "auto" : 100]}
              tick={{ fontSize: 12, dx: -50 }}
              tickCount={5}
              axisLine={false}
              tickLine={false}
            />

            <Tooltip
              labelStyle={{ color: lineColor, fontWeight: 'bold' }}
              itemStyle={{ color: '#343a40' }}
              formatter={(value) => new Intl.NumberFormat('fa-IR').format(value)}
              cursor={false}
            />

            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset={offsetStart} stopColor={gradientStart} />
                <stop offset={offsetEnd} stopColor={gradientEnd} />
              </linearGradient>
            </defs>

            <Area
              type="linear"
              dataKey="uv"
              stroke={lineColor}
              strokeWidth={2}
              fillOpacity={1}
              fill={`url(#${gradientId})`}
              dot={{ fill: lineColor, r: 6 }}
              activeDot={{ r: 8 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SimpleLineChart;
